import {useContext} from "react";
import {UserContext, UserInfo} from "../context/UserContext";

export function useUserInfo() : {userInfo : UserInfo, updateUserInfo : (userInfo : Partial<UserInfo>) => void, isMobile: boolean }{
    const userInfoHelpers = useContext(UserContext);
    return userInfoHelpers;
}
